
namespace RecordShield.Workspace {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.responsive()
    export class ActivationLog2Dialog extends Serenity.EntityDialog<ActivationLog2Row, any> {
        protected getFormKey() { return ActivationLog2Form.formKey; }
        protected getIdProperty() { return ActivationLog2Row.idProperty; }
        protected getLocalTextPrefix() { return ActivationLog2Row.localTextPrefix; }
        protected getNameProperty() { return ActivationLog2Row.nameProperty; }
        protected getService() { return ActivationLog2Service.baseUrl; }

        protected form = new ActivationLog2Form(this.idPrefix);
        protected afterLoadEntity() {
            super.afterLoadEntity();
            //Serenity.EditorUtils.setReadonly(this.form.SerialKey.element, true);
        }
        protected onSaveSuccess(response: Serenity.SaveResponse): void {

            // check that this is an insert
            if (this.isNew) {
                ActivationLogService.Retrieve(<any>{
                    EntityId: response.EntityId
                }, resp => {
                    if (resp.Entity.Status == 1) {
                        Q.notifySuccess("SerialKey Successfully Activated");
                    }
                    else {
                        Q.alert(resp.Entity.Log);
                    }
                });
            }
        }
    }
}